import { ComponentProps } from 'react';

export function CircleMinusIcon({ fill, ...restProps }: ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...restProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM5.17133 7C4.61905 7 4.17133 7.44772 4.17133 8C4.17133 8.55228 4.61905 9 5.17133 9H10.8287C11.381 9 11.8287 8.55228 11.8287 8C11.8287 7.44772 11.381 7 10.8287 7H5.17133Z"
        fill={fill || '#1C1C33'}
      />
    </svg>
  );
}
